import { render, staticRenderFns } from "./QRMenu.vue?vue&type=template&id=a2717460&lang=pug&"
import script from "./QRMenu.vue?vue&type=script&lang=js&"
export * from "./QRMenu.vue?vue&type=script&lang=js&"
import style0 from "./QRMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports